import { createAction, props } from '@ngrx/store';

export const loadProfileImage = createAction(
  '[Image] Load ProfileImage'
);

export const loadProfileImageSuccess = createAction(
  '[Image] Load Profile Image Success',
  props<{ image: any }>()
);

export const loadProfileImageFailure = createAction(
  '[Image] Load Profile Image Failure',
  props<{ error: any }>()
);

export const storeProfileImage = createAction(
  '[Image] Store Profile Image',
  props<{ data: any }>()
);

export const storeProfileImageSuccess = createAction(
  '[Image] Store Profile Image Success',
  props<{ image: any }>()
);

export const storeProfileImageFailure = createAction(
  '[Image] Store Profile Image Failure',
  props<{ error: any }>()
);

export const removeProfileImage = createAction(
  '[Image] Remove Profile Image'
);

export const removeProfileImageSuccess = createAction(
  '[Image] Remove Profile Image Success',
  props<{ image: any }>()
);

export const removeProfileImageFailure = createAction(
  '[Image] Remove Profile Image Failure',
  props<{ error: any }>()
);
